import QuestionPage from '@app-studio-web/ui/pages/QuestionPage'
import { useTranslation } from 'react-i18next'
import { useSubmit } from 'react-router-dom'

export default function QuestionCookFrequencyPage() {
  const submit = useSubmit()
  const { t } = useTranslation()

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    submit(event.currentTarget)
  }

  return (
    <QuestionPage
      heading={t('pages.onboarding.questionCookFrequency.heading')}
      buttons={[
        {
          text: t('pages.onboarding.questionCookFrequency.button1'),
          value: 'rarely',
        },
        {
          text: t('pages.onboarding.questionCookFrequency.button2'),
          value: 'sometimes',
        },
        {
          text: t('pages.onboarding.questionCookFrequency.button3'),
          value: 'often',
        },
        {
          text: t('pages.onboarding.questionCookFrequency.button4'),
          value: 'almost_daily',
        },
      ]}
      onSubmit={handleSubmit}
    />
  )
}
